export default "__VITE_ASSET__t46gb6uO__"